import PersonDisplayWidget from 'Components/people/components/PersonDisplayWidget';
import { Executive } from 'Types/PersonTypes';
import { backgroundColorParsing, getLangCookie } from 'Utils/UtilityFunctions';

import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PeopleCardListSkeleton from 'Components/common/skeleton/PeopleCardListSkeleton';
import {
  selectExtendedLoading, selectLoading, selectPeopleData, selectSearchResultsPage,
} from 'Selector/AffinitySearchSelector';
import { SearchResultsRequest } from 'Types/AffinitySearchTypes';
import { actions as actionsSearch } from 'Slice/AffinitySearchResultsSlice';
import { selectShowSelectedPeople } from 'Selector/CompaniesSelector';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { NO_PERSON_FOUND } from 'Utils/Constants';
import { useSearchParams } from 'react-router-dom';

const Wrapper = styled.div`
`;

type Props = {
  totalCount: number
  searchTerm: string
  handleView: () => void
  handleAddPerson: (person: Executive) => void
  handleRemovePerson: (person: Executive) => void
};

const SmartAccountPeopleSearch = function SmartAccountPeopleSearch(props: Props) {
  const {
    totalCount, searchTerm, handleView, handleAddPerson, handleRemovePerson,
  } = props;
  const dispatch = useDispatch();
  const { persons } = useSelector(selectPeopleData);
  const searchPage = useSelector(selectSearchResultsPage);
  const searchLoading: boolean = useSelector(selectLoading);
  const extendedLoading: boolean = useSelector(selectExtendedLoading);
  const showSelectedPeople = useSelector(selectShowSelectedPeople);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;

  const getMorePeople = () => {
    if (!searchLoading && !showSelectedPeople && (persons?.length || 0) < totalCount) {
      const obj: SearchResultsRequest = {
        query: searchTerm.trim(),
        screenName: 'company',
        page: searchPage + 1,
        sortCompanyId: companyIdParsed,
        defaultLanguage: getLangCookie(),
        inSap: true,
      };
      dispatch(actionsSearch.affinitySearchResultsLoading(obj));
    }
  };
  return (
    <Wrapper>
      <InfiniteScroll
        hasMore
        dataLength={persons?.length ?? 0}
        next={getMorePeople}
        loader={null}
        className={classNames('people-wrapper-smart  o-x-hidden')}
        height="auto"
      >
        {persons?.map((v: Executive) => (
          <PersonDisplayWidget
            key={`person-${v.personId}`}
            personId={v.personId}
            title={v.personName}
            profilePic={v.personImage}
            persona={backgroundColorParsing(v.personalityTypes)}
            company={v.companyName}
            designation={v.personDesignation}
            isFollowed={v.personAdded}
            personType={v.personType}
            isRecommended
            clicked={v.isAddClicked}
            showAddIcon
            onClickAdd={() => handleAddPerson(v)}
            onClickRemove={() => handleRemovePerson(v)}
            companyId={v?.companyId}
            location={v?.location}
          />
        ))}
        {searchLoading || extendedLoading ? (
          <>
            <PeopleCardListSkeleton key="skeleton-1" />
            <PeopleCardListSkeleton key="skeleton-2" />
          </>
        ) : null}
        {!persons?.length && !searchLoading && !extendedLoading
          ? (
            <div className="no-data-wrapper">
              <NoPersonsFound title={NO_PERSON_FOUND} />
              <span
                className="view-text"
                onClick={handleView}
                onKeyPress={handleView}
                role="button"
                tabIndex={0}
              >
                View People
              </span>
            </div>
          ) : null}
      </InfiniteScroll>
    </Wrapper>
  );
};

export default SmartAccountPeopleSearch;
